import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import BackToTop from "../components/BackToTop";
import { WOW } from "wowjs";
import "../css/global.css";
import "../css/WhatWeOffer.css";

const WhatWeOffer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const wow = new WOW({
      live: false,
    });
    wow.init();
  }, []);

  return (
    <div className="what-we-offer-page">
      <Header />

      <Banner
        backgroundImage="/wp-content/uploads/2016/02/DSC_0050.jpg"
        title="What We Offer"
      />

      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          <div className="breadcrumbs">
            <a href="/">Home</a> &gt; <span>What We Offer</span>
          </div>

          <h1 className="what-we-offer-title" data-aos="fade-right">What We Offer</h1>

          {/* Row 1 */}
          <div className="vc_row wpb_row vc_row-fluid wht-we-offer vc_row-no-padding">
            <div className="wpb_column vc_column_container vc_col-sm-6 vc_col-has-fill" data-aos="fade-right">
              <div className="vc_column-inner vc_custom_1460013559099">
                <div className="wpb_wrapper">
                  <div
                    className="vc_icon_element vc_icon_element-outer"
                  >
                    <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md">
                      {/* Updated to FontAwesome 5 classes */}
                      <span className="vc_icon_element-icon fas fa-user"></span>
                    </div>
                  </div>
                  <div
                    className="wpb_text_column wpb_content_element"
                  >
                    <div className="wpb_wrapper wht-we-offer-txt-left">
                      <p>
                        As a people oriented Company, Colombo Dockyard believes
                        in adaptability and inclusiveness rather than rigidity
                        and hierarchy in developing our Human Resources
                        policies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wpb_column vc_column_container vc_col-sm-6 vc_col-has-fill" data-aos="fade-left">
              <div className="vc_column-inner vc_custom_1460012857749">
                <div className="wpb_wrapper">
                  <div
                    className="vc_icon_element vc_icon_element-outer"
                  >
                    <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md">
                      {/* Updated to FontAwesome 5 classes */}
                      <span className="vc_icon_element-icon fas fa-users"></span>
                    </div>
                  </div>
                  <div
                    className="wpb_text_column wpb_content_element"
                  >
                    <div className="wpb_wrapper wht-we-offer-txt-box">
                      <p>
                        Employee participation in decision making, empowerment
                        and transparency are key attributes that are inbuilt
                        within the Human Resource value proposition of the
                        Company.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Row 2 */}
          <div className="vc_row wpb_row vc_row-fluid wht-we-offer vc_row-no-padding">
            <div className="wpb_column vc_column_container vc_col-sm-6 vc_col-has-fill" data-aos="fade-right">
              <div className="vc_column-inner vc_custom_1460012873822">
                <div className="wpb_wrapper">
                  <div
                    className="vc_icon_element vc_icon_element-outer"
                  >
                    <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md">
                      {/* Updated to FontAwesome 5 classes */}
                      <span className="vc_icon_element-icon fas fa-anchor"></span>
                    </div>
                  </div>
                  <div
                    className="wpb_text_column wpb_content_element"
                  >
                    <div className="wpb_wrapper wht-we-offer-txt-box">
                      <p>
                        Colombo Dockyard has been able to successfully align
                        management strategies and strategic business objectives
                        seamlessly, by encouraging constant dialogue,
                        instilling trust and demonstrating organizational
                        justice.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wpb_column vc_column_container vc_col-sm-6 vc_col-has-fill" data-aos="fade-left">
              <div className="vc_column-inner vc_custom_1460013574602">
                <div className="wpb_wrapper">
                  <div
                    className="vc_icon_element vc_icon_element-outer"
                  >
                    <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md">
                      {/* Updated to FontAwesome 5 classes (fa-file-text-o -> fas fa-file-alt) */}
                      <span className="vc_icon_element-icon fas fa-file-alt"></span>
                    </div>
                  </div>
                  <div
                    className="wpb_text_column wpb_content_element"
                  >
                    <div className="wpb_wrapper wht-we-offer-txt-left">
                      <p>
                        A standardized set of documented procedures (which are
                        ISO certified) provides a solid foundation, the Company
                        takes a holistic perspective in HR decision making
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default WhatWeOffer;
